import BaseClass from "../BaseClass.js";
import FormHandler from "./FormHandler.js";

export default class PostingFormHandler extends BaseClass {

    constructor(element) {
        super(element);

        this.$startTimeButton = null;
        this.$startTimeInput = null;
        this.starttimeUrl = null;
        this.init();
    }

    init() {
        // Explizit kein super.init();
        let $startTimeInput = this.$element.find('[name="starttime"]');
        if ($startTimeInput != undefined) {
            this.$startTimeInput = $startTimeInput;
            this.starttimeUrl = $startTimeInput.attr('data-url');
        }

        let $startTimeButton = this.$element.find('#posting_starttime_button');
        if ($startTimeButton != undefined) {
            this.$startTimeButton = $startTimeButton;
        }


        this.initListener();
    }

    initListener() {
        let mySelf = this;
        $(document).on('date:changed', function (event, data) {
            if (data.elementID == mySelf.$startTimeInput.attr('id')) {
                mySelf.saveEndTime();
            }
        });
    }

    saveEndTime() {
        let mySelf = this;
        let postData = 'starttime=' + this.$startTimeInput.val();

        let jqxhr = $.post(this.starttimeUrl, postData, function () {
        }, 'json')
            .done(function (data) {
                mySelf.handleAjaxResponse(data);
            })
            .fail(function (data) {
                if (data.responseJSON != undefined) {
                    // TODO Errorhandling
                    let options = {title: data.responseJSON.errors.starttime, customClass: 'error'};
                    let domElement = mySelf.$startTimeButton.get(0);
                    let tooltip = new bootstrap.Tooltip(domElement, options);
                    tooltip.show();

                }
            });

    }
}